var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup28(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 176.984,
    height: 151.375,
    viewBox: "0 0 176.984 151.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(-1140.412 -1312.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M2209.78,332.3V463.635h49.841V444.277a9.557,9.557,0,0,1,9.555-9.554h31.706a9.557,9.557,0,0,1,9.554,9.554v19.358h49.842V332.3Zm41.368,75.643a3.666,3.666,0,0,1-3.69,3.668h-14.412a3.662,3.662,0,0,1-3.669-3.668V387.993a3.663,3.663,0,0,1,3.669-3.669h14.412a3.667,3.667,0,0,1,3.69,3.669Zm0-38.018a3.667,3.667,0,0,1-3.69,3.669h-14.412a3.663,3.663,0,0,1-3.669-3.669V349.986a3.672,3.672,0,0,1,3.669-3.679h14.412a3.675,3.675,0,0,1,3.69,3.679Zm23.007-19.937a3.671,3.671,0,0,1,3.668-3.679h14.433a3.672,3.672,0,0,1,3.67,3.679v19.937a3.664,3.664,0,0,1-3.67,3.669h-14.433a3.662,3.662,0,0,1-3.668-3.669Zm10.873,79.715A17.371,17.371,0,1,1,2302.4,412.33a17.367,17.367,0,0,1-17.371,17.371m55.662-21.76a3.671,3.671,0,0,1-3.679,3.668H2322.6a3.648,3.648,0,0,1-3.668-3.668V387.993a3.649,3.649,0,0,1,3.668-3.669h14.413a3.672,3.672,0,0,1,3.679,3.669Zm0-38.018a3.672,3.672,0,0,1-3.679,3.669H2322.6a3.649,3.649,0,0,1-3.668-3.669V349.986a3.657,3.657,0,0,1,3.668-3.679h14.413a3.68,3.68,0,0,1,3.679,3.679Z",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M2368.235,327.437H2201.82c-4.958,0-7.173-5.077-3.335-7.648l9.743-6.553a6.051,6.051,0,0,1,3.35-.976h146.913a6,6,0,0,1,3.336.976l9.757,6.553c3.824,2.571,1.609,7.648-3.349,7.648",
    transform: "translate(-1056.125 999.996)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup28);
export default __webpack_public_path__ + "static/media/Group 28.79d05819a4e93cd24c7548fa55d6ca68.svg";
export { ForwardRef as ReactComponent };